import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { FAQS } from "../lib/faqs";

export default function FAQ() {
  return (
    <section id="faq" className="bg-white py-24 lg:py-32">
      <div className="max-w-wide mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-emerald-strong mb-4">
              Common questions
            </p>
            <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95] text-slate-950 mb-6">
              Straight answers.<br />Clear guidance.
            </h2>
            <p className="text-slate-600 text-lg leading-relaxed max-w-md">
              Answers to common questions about auto insurance, car loans,
              warranties, and car ownership costs — written to help you make
              smarter decisions.
            </p>
          </div>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    // Iter-130 — Speakable anchor for Google AI Overviews +
                    // Assistant. The schema.org SpeakableSpecification
                    // emitted via `speakableFaqPageLd` cssSelector matches
                    // these attribute values. Only top-N FAQs receive the
                    // annotation but emitting it on all of them is harmless
                    // (the schema selector restricts the scope).
                    data-speakable={`faq-question-${i}`}
                    className="font-display font-bold text-lg md:text-xl text-slate-950 py-6 hover:no-underline text-left"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-speakable={`faq-answer-${i}`}
                    className="text-slate-600 leading-relaxed text-base pb-6"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
